<template>
  <tr style="height: 30px;">
    <th>
      <table width="100%" style="background: white;">
        <tr>
          <td style="background: white; border: white; text-align: left; padding-left: 20px; vertical-align: middle;">
            <div class="td-box">
              <span class="td-text">{{roomName}}</span>
            </div>
          </td>
          <td style="background: white; border: white; color: #117CE9; font-weight: lighter; vertical-align: middle;">
            <div class="td-box">
              <span class="td-text">{{roomType}}</span>
            </div>
          </td>
          <td v-if="isManagerMode()" style="background: white; border: white; color: #117CE9; font-weight: lighter; vertical-align: middle;">
            <button class="btn btn-m " style="float: right;" data-toggle="modal" data-target="#roomSettingModal" @click="selectSettingRoom"><i class="icon-setting"></i></button>
          </td>
        </tr>
      </table>
    </th>
    <td v-for="(date, index) in dateArr" :style="{background: getBookColors(date), 'vertical-align' : (isUnavailable(date) ? 'middle': '')}" style="vertical-align: middle">

      <i v-if="isUnavailable(date) && isManagerMode()" class="icon-recyle mr-3" style="float: right; cursor: pointer; font-size: 14px;" data-toggle="modal" data-target="#deleteUnavailableRoom" @click="deleteUnavailableRoom(date)"></i>

<!--  예약 목록이 있는 날짜이고, 매니저 화면 일 때, 예약 목록을 표시함      -->
      <div v-for="(bookInfo, index) in getBookInfo(date)" v-if="(isBooked(date) && isManagerMode()) || $route.query.visitorId == bookInfo.roomGuest.visitorId" class="box" :class="[index>0 ? 'mt-2' : '']">
        <div class="box-header" :style="{'background' : (bookInfo.bookingStatusId == 4 ? '#05c55a': bookInfo.bookingStatusId == 5 ? '#C8C8C8' : '')}">
<!--          <h4>{{getBookInfo(date).roomGuest.visitor.ntreeTicket}}</h4>-->
          <h4 v-if="bookInfo.bookingStatusId == 1">예약대기
              <i v-if="bookInfo.fromDate == date.getTime()" class="badge mr-5 ml-5" style=" border: 1px solid #c8c8c8; height: 16px;">
                  <i class="icon-lineIcon-master"></i>
                  <span style="color: rgb(34, 34, 34); vertical-align: middle;">IN</span>
              </i>
              <i v-if="bookInfo.toDate == date.getTime()" class="badge mr-5 ml-5" style=" border: 1px solid #c8c8c8; height: 16px;">
                  <i class="icon-lineIcon-master"></i>
                  <span style="color: rgb(34, 34, 34); vertical-align: middle;">OUT</span>
              </i>
          </h4>
          <h4 v-if="bookInfo.bookingStatusId == 2" style="color: #05c55a">예약확정
              <i v-if="bookInfo.fromDate == date.getTime()" class="badge mr-5 ml-5" style=" border: 1px solid #c8c8c8; height: 16px;">
                  <i class="icon-lineIcon-master"></i>
                  <span style="color: rgb(34, 34, 34); vertical-align: middle;">IN</span>
              </i>
              <i v-if="bookInfo.toDate == date.getTime()" class="badge mr-5 ml-5" style=" border: 1px solid #c8c8c8; height: 16px;">
                  <i class="icon-lineIcon-master"></i>
                  <span style="color: rgb(34, 34, 34); vertical-align: middle;">OUT</span>
              </i>
          </h4>
          <h4 v-if="bookInfo.bookingStatusId == 3" style="color: #888">예약취소</h4>
          <h4 v-if="bookInfo.bookingStatusId == 4" style="color: #FFF">체크인
              <i v-if="bookInfo.fromDate == date.getTime()" class="badge mr-5 ml-5" style=" border: 1px solid #c8c8c8; height: 16px;">
                  <i class="icon-lineIcon-master"></i>
                  <span style="color: rgb(34, 34, 34); vertical-align: middle;">IN</span>
              </i>
              <i v-if="bookInfo.toDate == date.getTime()" class="badge mr-5 ml-5" style=" border: 1px solid #c8c8c8; height: 16px;">
                  <i class="icon-lineIcon-master"></i>
                  <span style="color: rgb(34, 34, 34); vertical-align: middle;">OUT</span>
              </i>
          </h4>
          <h4 v-if="bookInfo.bookingStatusId == 5" style="color: #FFF">체크아웃</h4>
          <button v-if="bookInfo.bookingStatusId < 3 && isManagerMode()" class="btn btn-m line-1" style="float: right;" data-toggle="modal" data-target="#roomCancelModal" @click="selectCancelRoom(bookInfo)"><i class="icon-close"></i></button>
          <button v-if="bookInfo.bookingStatusId < 3 && isManagerMode()" class="btn btn-m line-1 mr-3" style="float: right;" data-toggle="modal" data-target="#roomChangeModal" @click="selectChangeBooking(bookInfo)"><i class="icon-edit"></i></button>
          <button v-if="$route.query.visitorId == bookInfo.roomGuest.visitorId" class="btn btn-m line-1" style="float: right;" data-toggle="modal" data-target="#roomCancelModal" @click="selectCancelRoom(bookInfo)"><i class="icon-close"></i></button>
          <button v-if="bookInfo.bookingStatusId ==4 && isManagerMode()" class="btn btn-m" style="float: right;" data-toggle="modal" data-target="#roomCheckoutModal" @click="selectCheckoutBooking(bookInfo)"><i class="icon-key"></i></button>
          <small v-if="bookInfo.bookingStatusId == 1"> NTREE 예약 신청 완료</small>
          <small v-if="bookInfo.bookingStatusId == 2"> 담당자 승인 완료</small>
          <small v-if="bookInfo.bookingStatusId == 3"> NTREE는 취소 불가능하여 유지됩니다.</small>
          <small v-if="bookInfo.bookingStatusId == 4" style="color: #FFF"> IDC 입실 완료하였습니다.</small>
          <small v-if="bookInfo.bookingStatusId == 5" style="color: #FFF"> 체크아웃 완료되었습니다.</small>
        </div>
        <div class="box-body" :style="{'color' : (bookInfo.bookingStatusId == 3 || bookInfo.bookingStatusId == 5 ? '#888': '')}">
          <p>
            이름 : {{bookInfo.roomGuest.visitor.visitorName}}</br>
            소속 : {{bookInfo.roomGuest.visitor.visitorCompany}}</br>
            숙소 예약 티켓 : <a href="" @click.stop.prevent="openWindow(`https://ntree.navercorp.com/user/ticket/popup/`+bookInfo.bookingTicket+`.html`)" :class="[bookInfo.bookingStatusId == 3 || bookInfo.bookingStatusId == 5? '' : 'under-line']">{{bookInfo.bookingTicket}}</a></br>
            출입 신청 티켓 : <a href="" @click.stop.prevent="openWindow(`https://ntree.navercorp.com/user/ticket/popup/`+bookInfo.roomGuest.visitor.ntreeTicket+`.html`)" :class="[bookInfo.bookingStatusId == 3 || bookInfo.bookingStatusId == 5 ? '' : 'under-line']">{{bookInfo.roomGuest.visitor.ntreeTicket}}</a>
          </p>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>

  export default {
    props:['roomName', 'roomType', 'roomId', 'dateArr', 'bookingRooms', 'unavailableRooms'],
    data(){
      return {
      }
    },
    methods: {
      isWeekend(date) {
        return moment(date).day() == 0 || moment(date).day() == 6;
      },
      getBookingRoom(date){
        let timestamp = moment(date).valueOf();
        let bookingRoom = this.bookingRooms.filter((room) => {
          // return room.fromDate <= timestamp && room.toDate >= timestamp && room.roomId == this.roomId && room.bookingStatusId < 3
            return room.fromDate <= timestamp && room.toDate >= timestamp && room.roomId == this.roomId
        })

        return bookingRoom;
      },
      getUnavailableRoom(date){
        let timestamp = moment(date).valueOf();

        return this.unavailableRooms.filter(room => {
          return room.fromDate <= timestamp && room.toDate >= timestamp && room.roomId == this.roomId;
        })
      },
      isUnavailable(date){
          let unavailableRoom = this.getUnavailableRoom(date);

          return unavailableRoom.length > 0;
      },
      isBooked(date){
        // let timestamp = moment(date).valueOf();
        // let bookingRoom = this.bookingRooms.filter((room) => {
        //   return room.fromDate <= timestamp && room.toDate >= timestamp && room.roomId == this.roomId && room.bookingStatusId < 3
        // })
        // return bookingRoom.length > 0;
        let bookingRoom = this.getBookingRoom(date);
        let unavailableRoom = this.getUnavailableRoom(date);

        return bookingRoom.length > 0;
      },
      getBookColors(date){
        if(this.isWeekend(date)) return '#C8C8C8';

        let timestamp = moment(date).valueOf();
        let bookingRoom = this.getBookingRoom(date);
        let unavailableRoom = this.getUnavailableRoom(date);

        // let result = bookingRoom.length > 0 ? '#03C75A' : '#f6f7f8';
        let result;
        if(unavailableRoom.length > 0){
              result = '#C8C8C8';
        } else{
            debugger;
            let cancelRoom = bookingRoom.filter(room => room.bookingStatusId == 3);
            console.log("book : " + bookingRoom.length);
            console.log("can : " + cancelRoom.length);

            if(bookingRoom.length > 0 && (bookingRoom.length - cancelRoom.length) > 0){
                result = '#03C75A';
            }else {
                result = '#f6f7f8';
            }
        }


        return result;

      },
      getBookInfo(date){

        let bookingRoom = this.getBookingRoom(date);
        let unavailableRoom = this.getUnavailableRoom(date);

        let result = null;
        // if(bookingRoom.length > 0 && unavailableRoom.length == 0 && !this.isWeekend(date)){
        if(bookingRoom.length > 0){
          result = bookingRoom;
        }
        return result;
      },
      getDateInfo(){
        alert('asdf');
      },
      openWindow: function (link) {
        window.open(link);
      },
      isManagerMode(){
        return this.$route.path == '/app/manager/booking/calendar';
      },
      selectSettingRoom(){
          this.$emit('selectSettingRoom', this.roomId);
      },
      deleteUnavailableRoom(date){
        let unRooms = this.getUnavailableRoom(date)
        this.$emit('updateUnavailableRoom', unRooms[0]);
      },
      selectCancelRoom(booking){
          this.$emit('updateCancelRoom', booking);
      },
      selectChangeBooking(booking){
        this.$emit('updateChangeBooking', booking);
      },

      selectCheckoutBooking(booking){
        this.$emit('updateCheckoutBooking', booking);
      }
    }

  }
</script>

<style>

</style>